import { createSelector } from 'reselect';
import { LayoutType } from '../../../types/layouts.esm.js';

function getEnabledButtons(fieldsSelected, layoutType) {
  switch (layoutType) {
    case LayoutType.Default:
      {
        return {
          "delete": false,
          save: false,
          saveAs: false,
          apply: true
        };
      }
    case LayoutType.Custom:
      {
        return {
          "delete": false,
          save: false,
          saveAs: true,
          apply: fieldsSelected
        };
      }
    case LayoutType.Predefined:
      {
        return {
          "delete": false,
          save: false,
          saveAs: false,
          apply: true
        };
      }
    default:
      {
        return {
          "delete": true,
          save: fieldsSelected,
          saveAs: true,
          apply: fieldsSelected
        };
      }
  }
}
var enabledButtonsSelector = createSelector(function (props) {
  return props.fieldsSelected;
}, function (props) {
  return props.layoutType;
}, getEnabledButtons);

export { enabledButtonsSelector, getEnabledButtons };
//# sourceMappingURL=enabled-buttons-selector.esm.js.map
